import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["scope"],
    _excluded2 = ["headers", "apiUrl"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import fetch from 'isomorphic-unfetch';
import { toJPEGBlob } from '../../utils/tools';
import EncryptionService from '../encryption';

var fetchJson = function fetchJson() {
  var httpOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var encryptionService = arguments.length > 1 ? arguments[1] : undefined;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url) {
      var _options$headers;

      var options,
          encryptionOptions,
          scope,
          fetchOptions,
          keyId,
          aesFileEncryptionKey,
          ivFileEncryptionKey,
          encryption,
          withEncryption,
          aesKey,
          _encryptionService$st,
          httpOptionsHeaders,
          apiUrl,
          _httpOptions,
          requestHeaders,
          publicKey,
          iv,
          encryptedFormData,
          promises,
          results,
          _iterator,
          _step,
          _step$value2,
          key,
          value,
          encrypted,
          params,
          _args2 = arguments;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            encryptionOptions = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : {};
            scope = options.scope, fetchOptions = _objectWithoutProperties(options, _excluded);
            keyId = encryptionOptions.keyId, aesFileEncryptionKey = encryptionOptions.aesFileEncryptionKey, ivFileEncryptionKey = encryptionOptions.ivFileEncryptionKey, encryption = encryptionOptions.encryption;
            withEncryption = encryption && encryptionService !== null && ['auth', 'pat'].includes(scope) || url.includes('/registrations');
            aesKey = '';

            if (!withEncryption) {
              _context2.next = 15;
              break;
            }

            _context2.next = 9;
            return encryptionService === null || encryptionService === void 0 || (_encryptionService$st = encryptionService.storage) === null || _encryptionService$st === void 0 ? void 0 : _encryptionService$st.getItem('key');

          case 9:
            if (_context2.sent) {
              _context2.next = 12;
              break;
            }

            _context2.next = 12;
            return encryptionService === null || encryptionService === void 0 ? void 0 : encryptionService.generateAESKey();

          case 12:
            _context2.next = 14;
            return encryptionService === null || encryptionService === void 0 ? void 0 : encryptionService.getAESKey();

          case 14:
            aesKey = _context2.sent;

          case 15:
            httpOptionsHeaders = httpOptions.headers, apiUrl = httpOptions.apiUrl, _httpOptions = _objectWithoutProperties(httpOptions, _excluded2);
            requestHeaders = _objectSpread(_objectSpread(_objectSpread({}, httpOptionsHeaders !== null && httpOptionsHeaders !== void 0 ? httpOptionsHeaders : {}), {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }), (_options$headers = options.headers) !== null && _options$headers !== void 0 ? _options$headers : {});

            if (requestHeaders['Content-Type'] === null) {
              delete requestHeaders['Content-Type'];
            }

            if (requestHeaders.Accept === null) {
              delete requestHeaders.Accept;
            }

            if (!withEncryption) {
              _context2.next = 56;
              break;
            }

            if (!(scope === 'auth' || url.includes('/registrations'))) {
              _context2.next = 27;
              break;
            }

            _context2.next = 23;
            return fetch("".concat(apiUrl, "/pat-public/crypto/publickey")).then(function (res) {
              return res.text();
            });

          case 23:
            publicKey = _context2.sent;
            _context2.next = 26;
            return EncryptionService.encryptAESKeyWithRSA(aesKey, publicKey);

          case 26:
            requestHeaders['Aes-Key'] = _context2.sent;

          case 27:
            _context2.next = 29;
            return EncryptionService.generateIV();

          case 29:
            iv = _context2.sent;

            if (!fetchOptions.body) {
              _context2.next = 46;
              break;
            }

            if (!(fetchOptions.body instanceof FormData)) {
              _context2.next = 42;
              break;
            }

            encryptedFormData = new FormData();
            promises = _toConsumableArray(fetchOptions.body.entries()).map(function (_ref2) {
              var _ref3 = _slicedToArray(_ref2, 2),
                  entryKey = _ref3[0],
                  entryValue = _ref3[1];

              if (entryValue instanceof File) {
                var _entryValue$type;

                var blob = Promise.resolve(entryValue);

                if (entryValue !== null && entryValue !== void 0 && (_entryValue$type = entryValue.type) !== null && _entryValue$type !== void 0 && _entryValue$type.includes('image')) {
                  // eslint-disable-next-line no-await-in-loop
                  blob = toJPEGBlob(entryValue, 1920);
                }

                return new Promise(function (resolve, reject) {
                  return blob.then(function (b) {
                    return EncryptionService.encryptFile(aesFileEncryptionKey, ivFileEncryptionKey, b);
                  }).then(function (r) {
                    resolve([entryKey, r]);
                  }).catch(reject);
                });
              }

              return Promise.resolve([entryKey, entryValue]);
            });
            _context2.next = 36;
            return Promise.all(promises);

          case 36:
            results = _context2.sent;
            _iterator = _createForOfIteratorHelper(results);

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                _step$value2 = _slicedToArray(_step.value, 2), key = _step$value2[0], value = _step$value2[1];
                encryptedFormData.append(key, value);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }

            fetchOptions.body = encryptedFormData;
            _context2.next = 46;
            break;

          case 42:
            _context2.next = 44;
            return EncryptionService.encrypt64(aesKey, iv, fetchOptions.body);

          case 44:
            encrypted = _context2.sent;
            fetchOptions.body = JSON.stringify({
              cipher: encrypted.toString()
            });

          case 46:
            if (!requestHeaders.Authorization) {
              _context2.next = 50;
              break;
            }

            _context2.next = 49;
            return EncryptionService.encrypt64(aesKey, iv, requestHeaders.Authorization);

          case 49:
            requestHeaders.Authorization = _context2.sent;

          case 50:
            if (!requestHeaders.refresh) {
              _context2.next = 54;
              break;
            }

            _context2.next = 53;
            return EncryptionService.encrypt64(aesKey, iv, requestHeaders.refresh);

          case 53:
            requestHeaders.refresh = _context2.sent;

          case 54:
            requestHeaders['Key-Id'] = keyId;
            requestHeaders.Iv = iv;

          case 56:
            params = _objectSpread(_objectSpread(_objectSpread({}, fetchOptions), _httpOptions), {}, {
              headers: requestHeaders
            }, url.startsWith('/') ? {
              credentials: 'include'
            } : {});
            return _context2.abrupt("return", fetch(url, params).then( /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
                var contentType, isEncrypted, data, blob, text;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      contentType = response.headers.get('content-type');
                      isEncrypted = withEncryption && response.headers.get('iv'); // If server not response headers iv, it means response not encrypted, in case wrong key

                      if (!(isEncrypted || !(contentType !== null && contentType !== void 0 && contentType.includes('application/json')))) {
                        _context.next = 9;
                        break;
                      }

                      _context.next = 5;
                      return response.blob();

                    case 5:
                      blob = _context.sent;
                      data = blob.size ? blob : undefined;
                      _context.next = 13;
                      break;

                    case 9:
                      _context.next = 11;
                      return response.text();

                    case 11:
                      text = _context.sent;
                      data = text.length ? text : undefined;

                    case 13:
                      return _context.abrupt("return", {
                        status: response.status,
                        statusText: response.statusText,
                        headers: response.headers,
                        data: data
                      });

                    case 14:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));

              return function (_x2) {
                return _ref4.apply(this, arguments);
              };
            }()).then(function (_ref5) {
              var status = _ref5.status,
                  statusText = _ref5.statusText,
                  headers = _ref5.headers,
                  data = _ref5.data;
              var json;

              if (typeof data === 'string') {
                try {
                  json = JSON.parse(data);
                } catch (error) {
                  throw new Error(error);
                }
              }

              return {
                status: status,
                statusText: statusText,
                headers: headers,
                data: data,
                json: json
              };
            }));

          case 58:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};

export default fetchJson;
//# sourceMappingURL=fetchJson.js.map